<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PHystj/tc-custom/9780715338872.jpg?1700538183498" alt="This image is the cover for the book How to Sew: Appliqué, How to Sew"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How to Sew: Appliqué, How to Sew
      </h1>
      <p class="bookDescription body article font2">
        <b>A concise guide to appliqué sewing and design, with projects included.</b><br/><br/>Unleash your creativity with this book covering all of the basics of appliqué sewing and design!<br/><br/>In this short introductory guide, this highly adaptable skill is described in step-by-step detail, with:Easy to follow projectsProfessional tipsFun variations and ideas
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        The Editors of David & Charles
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles is an F+W Media Inc. company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1566514c